import "./style.css";

import { useState } from "react";

import { CustomBadge, ShowAllButton, TableCellText } from "@/components/atoms";
import { cn } from "@/lib/utils";

const TableCellShowAll = ({
  branches,
  classes,
  isLast,
}: {
  branches: string[];
  classes?: string;
  isLast: boolean;
}) => {
  const [showAll, setShowAll] = useState(false);

  const visibleBranches = showAll ? branches : branches.slice(0, 1);

  return (
    <TableCellText classes={classes} last={isLast}>
      <div className="flex flex-col gap-2 items-start">
        <div
          className={cn(
            "flex flex-col gap-2 items-start",
            showAll &&
              "max-h-[100px] overflow-y-scroll pr-4 pl-2 py-1 scrollbar-always"
          )}
        >
          {visibleBranches.map(branch => (
            <CustomBadge
              variant="outline"
              size="xs"
              key={branch}
              className="whitespace-nowrap"
            >
              {branch}
            </CustomBadge>
          ))}
        </div>

        {!showAll && branches.length > 1 && (
          <ShowAllButton onClick={() => setShowAll(true)} />
        )}
      </div>
    </TableCellText>
  );
};

export default TableCellShowAll;
